import { FC, PropsWithoutRef, useRef } from "react"
import { Icon } from "./icons/Icon"

export const PanelHandle: FC<
	PropsWithoutRef<{ label: string; onDrag: (delta: number) => void }>
> = ({ onDrag, label }) => {
	const dragRef = useRef<number | null>(null)

	const handleDrag = (e: MouseEvent) => {
		if (dragRef.current === null) {
			return
		}

		const delta = e.clientX - dragRef.current
		onDrag(delta)
	}

	const handleMouseUp = () => {
		dragRef.current = null
		document.removeEventListener("mousemove", handleDrag)
		document.removeEventListener("mouseup", handleMouseUp)
	}

	const handleMouseDown = (e: React.MouseEvent) => {
		dragRef.current = e.clientX
		document.addEventListener("mousemove", handleDrag)
		document.addEventListener("mouseup", handleMouseUp)
	}

	return (
		<div
			aria-label={label}
			role="button"
			className="flex h-full cursor-col-resize items-center border-x border-base-900"
			onMouseDown={handleMouseDown}
		>
			<Icon name="drag" size={12} />
		</div>
	)
}
